import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '../services/data.service';
import { API_ENDPOINT$ } from '../shared/index';

@Injectable({
  providedIn: 'root'
})
export class SiteUtilityService {
  private getAvailableKPIForProjectUrl = `${API_ENDPOINT$}/common/getAvailableKPIForProject`;
  private getUtilityProcessAndLoadsBySiteIdUrl = `${API_ENDPOINT$}/common/getUtilityProcessAndLoadsBySiteId`;
  private saveUtilityProcessForSiteUrl = `${API_ENDPOINT$}/manageproject/saveUtilityProcessForSite`;

  constructor(private dataService: DataService) {}

  /**
   * API call to get list of KPI utilities available for project
   *
   * @return {*}
   * @memberof SiteUtilityService
   */
  public getAvailableKPIForProject() {
    return this.dataService.getData(this.getAvailableKPIForProjectUrl);
    // return of(['Energy', 'Gas', 'Water']);
  }
  /**
   * API call to get process and loads for utility
   *
   * @param {string} siteId
   * @param {string} kpiName
   * @param {boolean} needMeterInfo
   * @return {*}  {Observable<any>}
   * @memberof SiteUtilityService
   */
  public getUtilityProcessAndLoadsBySiteId(
    siteId: string,
    kpiName: string,
    needMeterInfo: boolean
  ): Observable<any> {
    const model = {
      siteId: siteId,
      kpiName: kpiName,
      needMeterInfo: needMeterInfo
    };
    return this.dataService.postData(
      this.getUtilityProcessAndLoadsBySiteIdUrl,
      model
    );
  }

  /**
   * API call to save process for utility
   *
   * @param {*} params
   * @return {*}  {Observable<any>}
   * @memberof SiteUtilityService
   */
  public saveUtilityProcessForSite(params: any): Observable<any> {
    return this.dataService.postData(this.saveUtilityProcessForSiteUrl, params);
  }
}
